import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class Department extends Mappable {
  id!: string
  name!: string

  static create<Data>(attrs: Data) {
    return new Department().map(attrs)
  }
}
